import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoakkalkotcabservice() {



    const cardData = {

keyword: "Pune to Akkalkot Cab Service",

headingDescription:
    "Rising Cab Service offers safe, comfortable, and reliable Pune to Akkalkot Cab Service for devotees, families, and spiritual travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth long-distance pilgrimage journey. Our service includes doorstep pickup from Pune, flexible one-way and round-trip packages, 24/7 support, and transparent pricing, ensuring a peaceful and hassle-free darshan experience at Akkalkot Swami Samarth Maharaj Temple.",

topPlaces: [
    {
        title: "Shri Swami Samarth Temple, Akkalkot",
        description:
            "Shri Swami Samarth Temple in Akkalkot is one of the most powerful spiritual destinations in Maharashtra. It is dedicated to Swami Samarth Maharaj, believed to be an incarnation of Lord Dattatreya. Devotees visit for blessings, peace of mind, and spiritual guidance."
    },
    {
        title: "Vatavruksha Mandir",
        description:
            "Vatavruksha Mandir is the sacred site where Swami Samarth Maharaj is believed to have stayed under a banyan tree. It is a deeply spiritual place that attracts devotees seeking meditation, blessings, and divine energy."
    },
    {
        title: "Swami Samarth Math",
        description:
            "Swami Samarth Math is a well-maintained devotional center in Akkalkot where daily rituals, prayers, and bhajans are performed. It provides a peaceful environment for devotees to connect spiritually."
    },
    {
        title: "Dharashiv Route Temples",
        description:
            "The route from Pune to Akkalkot passes through several small temples and spiritual spots in the Solapur and Dharashiv regions, offering a calm and devotional travel experience."
    },
    {
        title: "Tuljapur Devi Temple (Nearby Extension)",
        description:
            "Many devotees extend their Akkalkot trip to Tuljapur to visit the famous Shri Tulja Bhavani Temple, one of the 51 Shakti Peeths, known for its powerful spiritual significance."
    },
    {
        title: "Solapur City Temples",
        description:
            "Solapur, located near Akkalkot, is home to several ancient temples and spiritual sites, adding religious value to the overall pilgrimage journey."
    },
    {
        title: "Sangameshwar River Point",
        description:
            "Sangameshwar River region near Akkalkot offers a peaceful natural environment where devotees often stop for relaxation during their spiritual journey."
    },
    {
        title: "Ganagapur Dattatreya Temple (Nearby Route)",
        description:
            "Ganagapur is another important spiritual destination dedicated to Lord Dattatreya, often included in extended pilgrimage tours along with Akkalkot."
    },
    {
        title: "Akkalkot Old Town Temples",
        description:
            "The old town area of Akkalkot features several small shrines and traditional temples that reflect the deep spiritual culture of the region."
    },
    {
        title: "Devotional Walking Routes",
        description:
            "The walking paths around Akkalkot Temple are filled with chanting devotees, spiritual stalls, and peaceful surroundings, enhancing the overall pilgrimage experience."
    }
],



services: [
  {
    name: "Pune to Akkalkot Cab Service",
    description: "Rising Cab Service offers Pune to Akkalkot Cab Service for a safe and comfortable pilgrimage journey to the holy town of Swami Samarth Maharaj. We provide well-maintained AC Sedan, SUV, Innova Crysta, and Tempo Traveller options with professional drivers, doorstep pickup, and 24x7 booking support. Ideal for families and devotees seeking a peaceful and reliable spiritual travel experience."
  },
  {
    name: "Pune to Akkalkot Taxi Service",
    description: "Book Pune to Akkalkot Taxi Service with Rising Cab Service for a smooth and reliable intercity pilgrimage ride. Our experienced chauffeurs ensure safe highway driving, timely pickup, clean vehicles, and comfortable seating for a stress-free journey to Akkalkot."
  },
  {
    name: "Pune to Akkalkot Cab Booking",
    description: "Rising Cab Service provides instant Pune to Akkalkot Cab Booking with multiple vehicle options, easy reservation process, and transparent pricing. Whether you need one way or round trip travel, we ensure hassle-free booking with 24x7 customer support."
  },
  {
    name: "Pune to Akkalkot One Way Cab",
    description: "Our Pune to Akkalkot One Way Cab service is ideal for passengers needing affordable drop-only travel to the temple town. We offer budget-friendly fares, clean AC vehicles, and professional drivers ensuring safe and comfortable long-distance travel."
  },
  {
    name: "Pune to Akkalkot Round Trip Cab",
    description: "Rising Cab Service offers Pune to Akkalkot Round Trip Cab for devotees planning same-day return or extended pilgrimage visits. Enjoy flexible waiting time, comfortable vehicles, and reliable service designed for family and group travel."
  },
  {
    name: "Pune to Akkalkot Darshan Cab",
    description: "Book Pune to Akkalkot Darshan Cab for a complete spiritual travel experience to Swami Samarth Maharaj Temple. We provide flexible stops for darshan, comfortable AC rides, and experienced drivers for a peaceful pilgrimage journey."
  },
  {
    name: "Pune to Akkalkot Innova Crysta Cab",
    description: "Rising Cab Service offers Pune to Akkalkot Innova Crysta Cab for premium comfort, spacious seating, and smooth long-distance travel. Perfect for families and groups seeking luxury, safety, and comfort during pilgrimage journeys."
  },
  {
    name: "Pune to Akkalkot SUV Cab Service",
    description: "Our Pune to Akkalkot SUV Cab Service is ideal for larger families and groups needing extra space and comfort. We provide well-maintained SUVs with AC, experienced drivers, and safe highway travel for a convenient pilgrimage experience."
  },
  {
    name: "Pune to Akkalkot Sedan Cab Service",
    description: "Book Pune to Akkalkot Sedan Cab Service for affordable and comfortable travel for small families and individuals. Our clean, air-conditioned sedans ensure smooth and budget-friendly pilgrimage transportation."
  },
  {
    name: "Pune to Akkalkot Temple Cab",
    description: "Rising Cab Service provides Pune to Akkalkot Temple Cab for devotees visiting Swami Samarth Maharaj Temple. We ensure timely pickup, safe driving, and comfortable travel arrangements for a peaceful darshan experience."
  },
  {
    name: "Pune to Akkalkot Outstation Cab",
    description: "Our Pune to Akkalkot Outstation Cab service offers reliable long-distance travel with professional drivers, clean vehicles, and flexible pickup options. We ensure safe, comfortable, and affordable intercity pilgrimage journeys."
  },
  {
    name: "Pune to Akkalkot Family Cab Service",
    description: "Rising Cab Service provides Pune to Akkalkot Family Cab Service with spacious vehicles, safe driving, and comfortable travel experience. Ideal for families planning a peaceful pilgrimage to Akkalkot."
  },
  {
    name: "Pune to Akkalkot Same Day Return Cab",
    description: "Book Pune to Akkalkot Same Day Return Cab for quick pilgrimage trips with flexible waiting time and hassle-free return travel. We ensure comfort, safety, and timely service for same-day darshan plans."
  },
  {
    name: "Pune to Akkalkot Tour Package",
    description: "Our Pune to Akkalkot Tour Package offers a complete pilgrimage experience with round trip cab service, flexible itinerary, comfortable vehicles, and professional drivers for a smooth spiritual journey."
  },
  {
    name: "Pune to Akkalkot Online Cab Booking",
    description: "Rising Cab Service provides easy Pune to Akkalkot Online Cab Booking with instant confirmation, multiple cab options, and 24x7 support. Enjoy a hassle-free booking experience for your pilgrimage travel needs."
  }
],

tableData: [
  ["Pune to Akkalkot Cab Service", "Pune to Akkalkot Taxi Service"],
  ["Pune to Akkalkot Cab Booking", "Pune to Akkalkot One Way Cab"],
  ["Pune to Akkalkot Round Trip Cab", "Pune to Akkalkot Darshan Cab"],
  ["Pune to Akkalkot Swami Samarth Cab", "Pune to Akkalkot Temple Cab"],
  ["Pune to Akkalkot Innova Crysta Cab", "Pune to Akkalkot Outstation Cab"],
  ["Pune to Akkalkot Tour Package", "Pune to Akkalkot Family Cab Service"],
  ["Pune to Akkalkot Same Day Return Cab", "Pune to Akkalkot Online Cab Booking"]
],



whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Akkalkot Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Akkalkot cab transportation for devotees, families, senior citizens, and spiritual travelers seeking a peaceful pilgrimage journey."
    },
    {
        WhyChooseheading: "Convenient Swami Samarth Darshan Travel",
        WhyChoosedescription: "Travel comfortably to the sacred town of Akkalkot and visit Shri Swami Samarth Maharaj Temple with well-planned transportation services."
    },
    {
        WhyChooseheading: "Customized Pilgrimage Tour Packages",
        WhyChoosedescription: "Choose from one-way travel, round-trip packages, same-day visits, overnight tours, and personalized pilgrimage itineraries."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Group",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for individual devotees and large groups."
    },
    {
        WhyChooseheading: "Combine Multiple Religious Destinations",
        WhyChoosedescription: "Travelers can include Pandharpur, Tuljapur, Gangapur, Solapur, and other spiritual destinations along with Akkalkot Darshan."
    },
    {
        WhyChooseheading: "Pickup Available Across Pune & PCMC",
        WhyChoosedescription: "Doorstep pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe and Comfortable Pilgrimage Travel",
        WhyChoosedescription: "Experienced drivers and well-maintained vehicles ensure a smooth and comfortable journey for devotees throughout the route."
    },
    {
        WhyChooseheading: "Ideal for Families and Senior Citizens",
        WhyChoosedescription: "Our private cab service offers flexibility, convenience, and comfortable travel arrangements for devotees of all age groups."
    }
]
};

const faqData = [
    {
        question: "Why is Akkalkot famous among devotees?",
        answer: "Akkalkot is renowned as the holy place associated with Shri Swami Samarth Maharaj and attracts devotees from across India."
    },
    {
        question: "Can I book a one-way cab from Pune to Akkalkot?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which vehicle is suitable for family travel to Akkalkot?",
        answer: "Ertiga and Innova Crysta are popular choices because they provide comfortable seating and ample luggage space."
    },
    {
        question: "Can Pandharpur and Akkalkot be covered in a single trip?",
        answer: "Yes, customized pilgrimage packages can include Pandharpur, Akkalkot, Tuljapur, Gangapur, and other nearby spiritual destinations."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for pilgrimage groups, family tours, and spiritual organizations."
    },
    {
        question: "Is the service suitable for senior citizens?",
        answer: "Yes, private cab transportation provides flexibility and convenience, making it ideal for elderly devotees."
    },
    {
        question: "Can I book a same-day Akkalkot Darshan trip?",
        answer: "Yes, same-day and overnight pilgrimage packages can be arranged depending on customer requirements."
    },
    {
        question: "Do you provide pickup from Pune Airport and Railway Station?",
        answer: "Yes, pickups are available from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended during festivals and special occasions?",
        answer: "Yes, advance reservations are advisable during Swami Samarth festivals, holidays, and peak pilgrimage seasons."
    },
    {
        question: "How can I book a Pune to Akkalkot Cab Service?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, website inquiries, or online booking forms with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Dattatray Kulkarni",
        feedback:
            "Our Swami Samarth Darshan trip to Akkalkot was organized wonderfully. The vehicle was comfortable, the driver was courteous, and the entire pilgrimage experience was peaceful.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Meenal Patwardhan",
        feedback:
            "The journey to Akkalkot with my family was smooth and well-planned. We were able to focus on Darshan while the travel arrangements were handled professionally.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Akkalkot Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-akkalkot-cab.jpg",
"description": "Book Pune to Akkalkot Cab Service with Rising Cab Service for safe and comfortable pilgrimage travel to Shri Swami Samarth temple. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-akkalkot-cab"
}
};










    return (
        <div>
<Helmet>
  <title>Pune to Akkalkot Cab Service | Swami Samarth Darshan Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Akkalkot Cab Service for safe and comfortable pilgrimage travel to Shri Swami Samarth temple. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to akkalkot cab, pune to akkalkot taxi, cab from pune to akkalkot, taxi from pune to akkalkot, pune to akkalkot cab service, pune to akkalkot taxi fare, pune to akkalkot one way cab, pune to akkalkot round trip taxi, pune to akkalkot cab booking, cheap pune to akkalkot cab, best pune to akkalkot taxi, sedan pune to akkalkot cab, suv pune to akkalkot taxi, akkalkot swami samarth cab pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/99.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoakkalkotcabservice;